import { appRouteHash, parseAppRoute } from "./appRoutes";
export const HISTORY_VIEWS_RESTORED98 = "berrier-history-views-restored";
export function navigationIndex98(state: unknown): number | null {
  const value = state && typeof state === "object" ? (state as { nav98?: unknown }).nav98 : null;
  return typeof value === "number" && Number.isSafeInteger(value) && value >= 0 && value < 1000000 ? value : null;
}
/** Return links are app-issued canonical identities, never arbitrary external URLs. */
export function safeReturn98(value: unknown): string | null {
  return typeof value === "string" && value.startsWith("#") && value.length <= 10000 && appRouteHash(parseAppRoute(value)) === value ? value : null;
}
